import React from "react";
import List from "./UL";

List.ol = List.withComponent("ol");
export default List;
